import React, { useState, useEffect } from "react";
import { Pencil, Eye, Trash2, Plus } from "lucide-react";
import "./EmployeeList.css";
import { GetAllEmployees } from "../../../../services/EmployeeMaster/Employee.service";
import { getAllRole } from "../../../../services/Role/Role.service";
import EmployeeModal from "./EmployeeModal";
import DeleteEmployeeModal from "./Deleteemployeemodal";

type ModalMode = "create" | "edit" | "view";

const EmployeeList: React.FC = () => {
  const [employees, setEmployees] = useState<any[]>([]);
  const [filteredEmployees, setFilteredEmployees] = useState<any[]>([]);
  const [roles, setRoles] = useState<any[]>([]); // ✅ roles from API

  const [searchText, setSearchText] = useState("");
  const [selectedRole, setSelectedRole] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState<ModalMode>("create");
  const [selectedEmployee, setSelectedEmployee] = useState<any | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [employeeToDelete, setEmployeeToDelete] = useState<any | null>(null);

  const itemsPerPage = 5;

  // ✅ Fetch Employees
  const fetchEmployees = async () => {
    try {
      const res = await GetAllEmployees();
      setEmployees(res.data.data);
      setFilteredEmployees(res.data.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  // ✅ Fetch Roles
  const fetchRoles = async () => {
    try {
      const res = await getAllRole();
      setRoles(res.data); // ✅ yahi correct hai
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  useEffect(() => {
    fetchEmployees();
    fetchRoles(); // 👈 call role API
  }, []);

  // 🔍 Search + Role Filter
  useEffect(() => {
    let data = [...employees];

    if (searchText) {
      data = data.filter((emp) =>
        `${emp.firstName} ${emp.lastName} ${emp.email} ${emp.mobile}`
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );
    }

    if (selectedRole) {
      data = data.filter((emp) => emp.role_name === selectedRole);
    }

    setFilteredEmployees(data);
    setCurrentPage(1);
  }, [searchText, selectedRole, employees]);

  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;

  const paginatedData = filteredEmployees
    .slice(startIndex, startIndex + itemsPerPage)
    .map((item, index) => ({
      ...item,
      serial: startIndex + index + 1,
    }));

  // --- Modal helpers ---
  const openCreate = () => {
    setSelectedEmployee(null);
    setModalMode("create");
    setShowModal(true);
  };

  const openView = (emp: any) => {
    setSelectedEmployee(emp);
    setModalMode("view");
    setShowModal(true);
  };

  const openEdit = (emp: any) => {
    setSelectedEmployee(emp);
    setModalMode("edit");
    setShowModal(true);
  };

  const openDelete = (emp: any) => {
    setEmployeeToDelete(emp);
    setShowDeleteModal(true);
  };

  return (
    <div className="employee-container">
    <div className="header-bar">
  <div className="filters-row">
    <input
      type="text"
      placeholder="Search by name, email, mobile..."
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
      className="filter-input"
    />

    <select
      value={selectedRole}
      onChange={(e) => setSelectedRole(e.target.value)}
      className="filter-select"
    >
      <option value="">All Roles</option>
      {roles.map((role: any) => (
        <option key={role.role_id} value={role.role_name}>
          {role.role_name}
        </option>
      ))}
    </select>
  </div>

  <button className="add-btn" onClick={openCreate}>
    <Plus size={16} /> Add Employee
  </button>
</div>

      <table className="employee-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>Code</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Mobile</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((emp) => (
            <tr key={emp.id}>
              <td>{emp.serial}</td>
              <td>{emp.employeeCode}</td>
              <td>{emp.firstName} {emp.lastName}</td>
              <td>{emp.email}</td>
              <td>{emp.role_name}</td>
              <td>{emp.mobile}</td>
              <td>
                <span className={`status ${emp.status}`}>{emp.status}</span>
              </td>
              <td>
                <div className="actions">
                  <Eye size={16} onClick={() => openView(emp)} />
                  <Pencil size={16} onClick={() => openEdit(emp)} />
                  <Trash2 size={16} onClick={() => openDelete(emp)} />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination">
        <button
          onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

      <EmployeeModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={fetchEmployees}
        mode={modalMode}
        employeeData={selectedEmployee}
      />

      <DeleteEmployeeModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onSuccess={fetchEmployees}
        employeeData={employeeToDelete}
      />
    </div>
  );
};

export default EmployeeList;